import { InjectionToken } from '@angular/core';

export const USE_CLOUD_FUNCTIONS_EMULATOR = new InjectionToken<boolean>('UseCloudFunctionsEmulator');
